import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Logo from '../assets/vectors/logo-vendora-negative-2.svg'

const Header = (props) => {
    const [title, setTitle] = useState(props.title)
    const [link, setLink] = useState(props.link)
    const [description, setDescription] = useState(props.description)
    const [coverImage, setCoverImage] = useState(props.coverImage)

    useEffect(() => {
        setTitle(props.title || 'Vendora | Más que un negocio, un movimiento')
        setLink(props.link || 'https://vendora.com.mx')
        setDescription(props.description || 'Vendora | Más que un negocio, un movimiento')
        setCoverImage(props.coverImage || 'https://vendora.com.mx/assets/coverphoto.png')
    }, [props])

    return(
        <header className="signup-header">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
                <link rel="canonical" href={link} />
                <meta name="author" content="@vendora" />

                <link rel="apple-touch-icon" sizes="57x57" href="/assets/images/apple-icon-57x57.png" />
                <link rel="apple-touch-icon" sizes="60x60" href="/assets/images/apple-icon-60x60.png" />
                <link rel="apple-touch-icon" sizes="72x72" href="/assets/images/apple-icon-72x72.png" />
                <link rel="apple-touch-icon" sizes="76x76" href="/assets/images/apple-icon-76x76.png" />
                <link rel="apple-touch-icon" sizes="114x114" href="/assets/images/apple-icon-114x114.png" />
                <link rel="apple-touch-icon" sizes="120x120" href="/assets/images/apple-icon-120x120.png" />
                <link rel="apple-touch-icon" sizes="144x144" href="/assets/images/apple-icon-144x144.png" />
                <link rel="apple-touch-icon" sizes="152x152" href="/assets/images/apple-icon-152x152.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/assets/images/apple-icon-180x180.png" />
                <link rel="icon" type="image/png" sizes="192x192"  href="/assets/images/android-icon-192x192.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/assets/images/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="96x96" href="/assets/images/favicon-96x96.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/assets/images/favicon-16x16.png" />
                <link rel="manifest" href="/manifest.json" />
                <meta name="msapplication-TileColor" content="#ffffff" />
                <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
                <meta name="theme-color" content="#ffffff" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@vendora" />
                <meta name="twitter:creator" content="@vendora" />
                <meta name="twitter:title" content={title} />
                <meta name="twitter:description" content={description} />
                <meta name="twitter:image:src" content={coverImage} />

                <meta name="og:title" content={title} />
                <meta name="og:site_name" content="Vendora"/>
                <meta name="og:url" content={link} />
                <meta name="og:type" content="website" />
                <meta name="og:description" content={description} />
                <meta name="og:image" content={coverImage} />
            </Helmet>
            <section className="signup-navbar">
                <div className="signup-logo">
                    <a href="/">
                        <img src={Logo} alt="Vendora" />
                    </a>
                </div>
            </section>
        </header>
    )

}

export default Header